import React, {PropTypes} from 'react';

class UserLocation extends React.Component {

  componentDidMount () {
    // Get the user's location
    this.props.userLocationActions.fetchLocation();
  }

  componentDidUpdate () {
    let country_code_2 = this.props.userLocation.country_code_2;
    let countries = this.props.countries;

    let country = undefined;
    let from_city_id = undefined;
    let from_city_name = undefined;
    let currency_code = 'USD';

    // If undefined, guess the best default city depending on the user's country
    // They can change it later

    country = countries[country_code_2];

    // Maybe we don't have this country in our list, it could stay undefined
    if (country) {
      from_city_id = country.largest_city_id;
      from_city_name = country.largest_city_name;
      currency_code = country.currency_code;
    }

    if (from_city_id == 'none') {
      from_city_id = undefined;
      from_city_name = undefined;
    }

    // Set the default, only if not done already, otherwise it creates a loop of death
    if(!this.props.userLocation.default_city_has_been_set && !this.props.userLocation.isFetching && !this.props.userLocation.customized){
      this.props.userLocationActions.setDefaultCity(from_city_id, from_city_name);
      this.props.userLocationActions.setDefaultCurrency(currency_code);

      // As son as we have a guess for a city, we fetch the prices
      // city_id can be null as componentDidUpdate seems to fire once when the components loads
      // probably because of the change on isFetching
      if(from_city_id){
        this.props.pricesActions.fetchPrices(from_city_id);
      }
    }
  }

  render() {
    return false;
  }
}

UserLocation.propTypes = {
  userLocation: PropTypes.object.isRequired,
  userLocationActions: PropTypes.object.isRequired,
  countries: PropTypes.object.isRequired,
  pricesActions: PropTypes.object.isRequired
};

export default UserLocation;



/** WEBPACK FOOTER **
 ** ./src/components/UserLocation.js
 **/